export default __webpack_public_path__ + "static/media/logo.522ea777.png";